import type { Task, TaskAssigneeUser } from '@/types';

export function getTaskAssignees(task: { assignees?: TaskAssigneeUser[] | null }): TaskAssigneeUser[] {
  return task.assignees ?? [];
}

export function formatAssigneeLabel(assignees: Pick<TaskAssigneeUser, 'displayName'>[]): string {
  if (assignees.length === 0) return '';
  if (assignees.length === 1) return assignees[0].displayName;
  if (assignees.length === 2) return `${assignees[0].displayName}, ${assignees[1].displayName}`;
  return `${assignees[0].displayName} +${assignees.length - 1}`;
}

export function taskHasUserAssignees(task: Task): boolean {
  return getTaskAssignees(task).length > 0;
}

export function isTaskUnassignedPeople(task: Task): boolean {
  return !taskHasUserAssignees(task) && !task.assignedTeamId;
}
